module.exports = __webpack_public_path__ + "static/img/free-trial.140e6240.jpg";